import React from "react";
import styles from "./Listing.module.scss";
import Image from "next/image";
function ListingOptimize() {
  return (
    <div className={styles["listing-wrapper"]}>
      <div className={styles["listing-content"]}>
        <h2>Uncovering Key Trend by decoding customer reviews</h2>
        <p>
          Socommerz&apos;s Semantic Analyser modules systematically Analyses review
          data.Leveraging these insights allows brands to make informed
          decisions regarding product development, marketing strategies, and
          customer engagement. Ultimately, decoding customer reviews transforms
          feedback into actionable strategies that drive growth and enhance
          customer satisfaction.
          <br></br>
          Now, businesses can uncover key trends that highlight emerging
          customer needs and product performance. This process not only
          identifies recurring themes and sentiments but also reveals areas for
          improvement and innovation.
        </p>
      </div>
      <div className={styles["listing-image"]}>
        <Image
          src={"/reviewrating/analysis.png"}
          alt=""
          width={500}
          height={400}
          className={styles["listing1-image"]}
        ></Image>
      </div>
    </div>
  );
}

export default ListingOptimize;
